/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

class HomeworkStore extends BaseStore{

    constructor(){
        super();
        this.currentHomeworkTasks = [];
        this.temporaryStore = [];
        this.massDataHomeworks = [];
    }

    clearTemporaryStore() {
        this.temporaryStore = [];
    }

    addToTemporaryStore(data) {
        this.temporaryStore.push(data);
    }

    addNewTask(type, uid, games, data, title, difficulty, exam_catalog_uid) {
        var newTask = {}
        newTask.type = type;
        newTask.uid = uid;
        newTask.games = games;
        for (var i =0; i < newTask.games.length; i++) {
            newTask.games[i].difficulty = difficulty;
            newTask.games[i].exam_catalog_uid = exam_catalog_uid;
        }
        newTask.data = data;
        newTask.title = title;
        newTask.difficulty = difficulty;
        newTask.exam_catalog_uid = exam_catalog_uid;
        for (var i =0; i < this.currentHomeworkTasks.length; i++) {
            if (this.currentHomeworkTasks[i].type == type && this.currentHomeworkTasks[i].uid == uid) {
                this.currentHomeworkTasks[i].games = games;
                return;
            }
        }
        this.currentHomeworkTasks.push(newTask);
    }

    addNewEditTask(type, uid, games, data, title, difficulty, exam_catalog_uid) {
        var newTask = {}

        for(var idx = 0 ; idx < this.currentHomeworkTasks.length; idx++)
        {
         //   if(this.currentHomeworkTasks[idx].uid == uid && this.currentHomeworkTasks[idx].type == type) return;
        }

        newTask.type = type;
        newTask.uid = uid;
        newTask.games = games;
        for (var i =0; i < newTask.games.length; i++) {
            newTask.games[i].difficulty = difficulty;
            newTask.games[i].exam_catalog_uid = exam_catalog_uid;
        }
        newTask.data = data;
        newTask.title = title;
        newTask.difficulty = difficulty;
        newTask.exam_catalog_uid = exam_catalog_uid;
        for (var i =0; i < this.currentHomeworkTasks.length; i++) {
            if (this.currentHomeworkTasks[i].type == type && this.currentHomeworkTasks[i].uid == uid) {

                for(var j = 0 ; j < games.length; j++)
                {
                    var block = false;
                    for(var a = 0; a < this.currentHomeworkTasks[i].games.length; a++)
                    {
                        if(this.currentHomeworkTasks[i].games[a].uid == games[j].uid)
                        {
                            block = true; break;
                        }
                    }

                    if(!block)
                    {
                        this.currentHomeworkTasks[i].games.push(games[j])
                    }
                }

                return;
            }
        }
        this.currentHomeworkTasks.push(newTask);
    }

    clear() {
        this.currentHomeworkTasks = [];
        this.temporaryStore = [];
    }

    getCurrentHomeworks() {
        return this.currentHomeworkTasks;
    }

    setSelectedMassData(massData) {
        this.massDataHomeworks = massData;
    }

    getSelectedMassData() {
        return this.massDataHomeworks;
    }

    getCurrentTime() {
        var taskCounter = 0;
        for (var i = 0; i < this.currentHomeworkTasks.length; i++) {
            taskCounter += this.currentHomeworkTasks[i].games.length;
        }
        return taskCounter * 180;
    }
}

export default new HomeworkStore();